import React from 'react';
import styled from 'styled-components';

import { theme } from '../../../style/theme';
import { PostPreview } from './PostPreview';

const PostWrapperStyles = styled.section`
  display: flex;
  flex-wrap: wrap;
  margin: 10rem auto 5rem auto;
  @media (max-width: 500px) {
    margin: 6rem auto 5rem auto;
  }
  max-width: ${theme.maxContainer.lg};
`;

const TitleStyle = styled.h2`
  flex-basis: 100%;
  padding-left: 3rem;
`;

export const Posts = (props) => {
  const posts = props.posts.slice(0, 3);
  return (
    <PostWrapperStyles id="blog">
      <TitleStyle>Siga o blog da SparkOne</TitleStyle>
      {posts.map(post => <PostPreview key={post.node.date} {...post.node} />)}
    </PostWrapperStyles>
  );
};

export default Posts;



// WEBPACK FOOTER //
// ./src/components/Index/Posts/index.jsx